// otpInputField.style.js
export const otpInputFieldStyles = {
    "@media(max-width: 768px)": {
      width: 400
    },
    "@media(max-width: 500px)": {
      width: "100%",
    },
    "@media(max-width: 400px)": {
      gap: '10px'
    },
    '& .MuiInputBase-input': {
      backgroundColor: 'white',
      color: 'black',
      height: '28px',
      fontSize: '18px',
      padding: { xs: '10px', sm: '15px' },
      borderRadius: '8px',
      textAlign: 'center',
      '&::placeholder': { // placeholder
        color: 'black',
        opacity: 0.5, 
        transform: 'translateY(15px)', // Adjust Y position to baseline
      },
      '&:focus': {
        outline: 'none', // Remove outline on focus
        border: 'none', // Remove border on focus
      },
    },
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderRadius: '8px',
        borderColor: 'white',
      },
      '&:hover fieldset': {
        borderRadius: '8px',
        borderColor: 'white',
      },
      '&.Mui-focused fieldset': {
        borderRadius: '8px',
        borderColor: 'transparent', // Hide border when focused
      },
    },
  };
  